var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zu-empty"},[_c('div',{staticClass:"zu-empty-img-box"},[_vm._t("img",function(){return [_c('img',{staticClass:"zu-empty-img",attrs:{"src":_vm.imgSrc,"alt":_vm.text}})]})],2),_c('div',{staticClass:"zu-empty-text"},[_vm._v(_vm._s(_vm.text))]),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }